module.exports = __webpack_public_path__ + "img/ch.6539c600.svg";